import { useFolders } from '../../hooks/useFolders'
import { Folder } from '../../types/models'

interface FolderSelectorProps {
  selectedFolderId?: string | null
  onFolderSelect: (folderId: string | null) => void
  placeholder?: string
  disabled?: boolean
}

export function FolderSelector({
  selectedFolderId,
  onFolderSelect,
  placeholder = "フォルダを選択",
  disabled = false
}: FolderSelectorProps) {
  const { data: foldersData, isLoading, error } = useFolders()
  
  const folders = foldersData?.folders || []
  const selectedFolder = folders.find(f => f.id === selectedFolderId)

  if (error) {
    return (
      <div className="text-red-600 text-sm">
        フォルダの読み込みに失敗しました
      </div>
    )
  }

  return (
    <div className="relative">
      <select
        value={selectedFolderId || ''}
        onChange={(e) => onFolderSelect(e.target.value || null)}
        disabled={disabled || isLoading}
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
      >
        <option value="">
          {isLoading ? '読み込み中...' : placeholder}
        </option>
        {folders.map((folder) => (
          <option key={folder.id} value={folder.id}>
            {folder.name} ({folder.documentCount}件)
          </option>
        ))}
      </select>
      
      {/* 選択されたフォルダの色表示 */}
      {selectedFolder && (
        <div 
          className="absolute right-8 top-1/2 transform -translate-y-1/2 w-3 h-3 rounded-full"
          style={{ backgroundColor: selectedFolder.color || '#3B82F6' }}
        />
      )}
    </div>
  )
}
